define(function (require, exports, module) {
    'use strict';

    var escapeForHtml = require('lib/escapeForHtml');
    var UploadError = require('./UploadError');
    const { captureException } = require('@sentry/browser');

    /**
     * @constructor
     * @extends {UploadError}
     * @param {Error} stack
     * @param {string} source
     * @param {Error} error
     */
    function JavaScriptError(stack, source, error) {
        UploadError.apply(this, arguments);

        var details = JavaScriptError.getErrorDetails(error);

        this.message = this.message.replace('{DETAILS}', details);
        this.error = error;

        if (!this.stack && error.stack) {
            this.stack = error;
        }

        captureException(this.error);
    }

    Object.assign(JavaScriptError, {
        /**
         * @param {Error} error
         * @returns {string}
         */
        getErrorStack: function (error) {
            var stack = error.stack;

            if (stack) {
                var origin = location.origin; // TODO: cross-browser?

                stack = stack.split(origin).join('');
                stack = stack.split('    at ').join('');
                // TODO: normalize stack
            }

            return stack;
        },

        /**
         * @param {Error|DOMException} error
         * @returns {string|undefined} – e.g. "NOT_FOUND_ERR" or "MEDIA_ERR_DECODE"
         */
        getErrorCodeName: function (error) {
            var name;
            var code = error.code;
            var Constructor = error.constructor;

            if (code && Constructor) {
                name = Object.keys(Constructor).find(function (key) {
                    // e.g. DOMException.NOT_FOUND_ERR or MediaError.MEDIA_ERR_DECODE
                    var isCodeName = key.toUpperCase() === key;

                    return isCodeName && Constructor[key] === code;
                });
            }

            if (!name && error.name !== 'Error') {
                // e.g. DOMException.name → "Error"
                name = error.name; // e.g. "NotFoundError" or "SecurityError"
            }

            return name;
        },

        /**
         * @param {Error|DOMException} error
         * @returns {string} – e.g. "TypeError", "DOMException" or "MediaError"
         */
        getErrorType: function (error) {
            var type;
            var name;
            var Constructor = error.constructor;

            if (Constructor) {
                // Object.create(null).constructor → undefined
                var proto = Constructor.prototype;

                if (proto && window.Symbol && Symbol.toStringTag) {
                    name = proto[Symbol.toStringTag]; // e.g. "TypeError", "DOMException" or "MediaError"
                }

                if (!name) {
                    name = Constructor.name; // e.g. "TypeError", "DOMException" or "MediaError"
                }

                if (name !== 'Object') {
                    type = name;
                }
            }

            if (!type) {
                type = Object.prototype.toString.call(error); // e.g. "[object MediaError]"
                type = type.slice(8, -1); // "[object MediaError]" → "MediaError"
            }

            return type;
        },
        /**
         * @param {Error|DOMException} error
         * @returns {string}
         */
        getErrorDetails: function (error) {
            var type = JavaScriptError.getErrorType(error);
            var stack = JavaScriptError.getErrorStack(error);
            var codeName = JavaScriptError.getErrorCodeName(error);
            var codeNumber = error.code;
            var message = error.message;
            var details;

            if (stack) {
                details = '{STACK}';
            } else if (message && codeName) {
                details = '{TYPE}: {CODE_NAME} – {MESSAGE}';
            } else if (message && codeNumber) {
                details = '{TYPE}: code {CODE_NUMBER} – {MESSAGE}';
            } else if (codeName) {
                details = '{TYPE}: {CODE_NAME}';
            } else if (codeNumber) {
                details = '{TYPE}: code {CODE_NUMBER}';
            } else if (message) {
                details = '{TYPE}: {MESSAGE}';
            } else {
                details = '{TYPE}';
            }

            details = details.replace('{TYPE}', type);

            if (stack) {
                details = details.replace('{STACK}', escapeForHtml(stack));
            }

            if (message) {
                details = details.replace('{MESSAGE}', escapeForHtml(message));
            }

            if (codeName) {
                details = details.replace('{CODE_NAME}', codeName);
            }

            if (codeNumber) {
                details = details.replace('{CODE_NUMBER}', codeNumber);
            }

            return details;
        },
    });

    JavaScriptError.prototype = Object.assign(Object.create(UploadError.prototype), {
        constructor: JavaScriptError,
        className: 'JavaScriptError',
        radarName: 'error_{SOURCE}_js',
        message: 'Произошла JavaScript ошибка: <pre>{DETAILS}</pre>',
        error: null,

        toLogStringPattern: '[{TIME}] {ID} {SOURCE} {CLASS_NAME} { {META} }: {ERROR}',

        toLogString: function () {
            var result = UploadError.prototype.toLogString.apply(this, arguments);

            result = result.replace('{ERROR}', String(this.error));

            return result;
        },

        getDetails: function () {
            var details = UploadError.prototype.getDetails.apply(this, arguments);

            details.error = String(this.error);

            return details;
        },
    });

    module.exports = JavaScriptError;
});
